<template>
  <div class="evaluation">
    <div class="title">
      <b>班级数据</b>
      <!-- <el-button type="text" class="btn" @click="showExport = true"
        >数据导出 <i class="el-icon-download"></i
      ></el-button> -->
    </div>
    <div class="main">
      <div class="rank_row">
        <div class="team_box">
          <div class="box_title">
            <span class="tab">{{ isEnd ? "团队期末排行" : "团队排行" }}</span>
            <!-- <el-button class="export-btn" type="text" @click="handleExport(1)"
              >导出 <i class="el-icon-download"></i
            ></el-button> -->
          </div>
          <!-- <p class="tr">
            <span class="idx">排名</span>
            <span>团队名称</span>
            <span class="score ml" v-if="classInfo.douyin">实战成绩</span>
            <span class="score">成绩</span>
          </p> -->
          <div class="list_box">
            <p
              class="row"
              v-for="(item, idx) in teamRankList"
              :key="item.teamId"
              @click="handleShowList('team', item.teamId, item.teamName)"
            >
              <span class="idx">{{ idx + 1 }}</span>
              <span class="name">{{ item.teamName }}</span>
              <!-- <span class="score oc" v-if="classInfo.douyin">
                {{ (item.douyinScore || 0).toFixed(1) }}分</span
              > -->
              <span class="score">{{ (item.score || 0).toFixed(1) }}分 </span>
            </p>
          </div>
        </div>
        <!-- <div class="radar">
          <div class="box_title">评价雷达图</div>
          <div class="radar_box">
            <ve-radar
              width="280px"
              height="220px"
              :data="chartData"
              :settings="radarSet"
              :extend="chartExtend"
            ></ve-radar>
          </div>
        </div> -->
        <div class="personal_box">
          <div class="box_title">
            <span class="tab">{{ isEnd ? "个人期末排行" : "学生排行" }}</span>
            <!-- <el-button class="export-btn" type="text" @click="handleExport(0)"
              >导出 <i class="el-icon-download"></i
            ></el-button> -->
          </div>
          <!-- <p class="tr">
            <span class="idx">排名</span>
            <span>姓名</span>
            <span class="score ml" v-if="classInfo.douyin">实战成绩</span>
            <span class="score">成绩</span>
          </p> -->
          <div class="list_box">
            <p
              class="row"
              v-for="(item, idx) in rankList"
              :key="item.userId"
              @click="handleShowList('user', item.userId, item.nickName)"
            >
              <span class="idx">{{ idx + 1 }}</span>
              <span class="name">{{ item.nickName }}</span>
              <!-- <span class="score oc" v-if="classInfo.douyin"
                >{{ (item.douyinScore || 0).toFixed(1) }}分</span
              > -->
              <span class="score">{{ (item.score || 0).toFixed(1) }}分 </span>
            </p>
          </div>
        </div>
      </div>

      <div class="score_row">
        <div class="score_box" v-for="item in scoreList" :key="item.id">
          <p class="score_title">{{ item.title }}</p>
          <div class="circle_box" @click="goDetail(item.path, item.id)">
            <!-- <el-progress
              type="circle"
              :percentage="item.score"
              color="#1de0fe"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress> -->
            <span class="score-text">{{ item.score }}</span>
            <span style="margin-left: 5px">分</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="titleText + '的章节成绩列表'"
      :visible.sync="showList"
      center
      width="60%"
      ><el-table
        class="score-list"
        :data="chapterScoreList"
        height="calc(50vh)"
        row-key="chapterId"
        default-expand-all
      >
        <el-table-column prop="chapterName" label="章节" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.chapterName }}</span>
            <el-tag
              v-if="scope.row.sz"
              style="margin-left: 10px"
              effect="dark"
              size="mini"
              >实训</el-tag
            >
            <el-tag
              v-if="scope.row.mock"
              style="margin-left: 10px"
              effect="dark"
              type="warning"
              size="mini"
              >仿真实训</el-tag
            >
            <el-tag
              v-if="scope.row.teamGrade"
              style="margin-left: 10px"
              effect="dark"
              type="success"
              size="mini"
              >评价</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="zsScore"
          label="知识考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tdScore"
          label="态度考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="jnScore"
          label="技能考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="syScore"
          label="素养考核"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="totalScore"
          label="总分"
          width="80"
          align="center"
        >
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="数据导出" :visible.sync="showExport" center width="30%">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <div style="margin: 15px 0"></div>
      <el-checkbox-group v-model="checked" @change="handleCheckedChange">
        <el-checkbox v-for="t in items" :label="t.key" :key="t.key">{{
          t.label
        }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showExport = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleExportData"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  classAvg,
  teamRanking,
  personalRanking,
  finalScoreList,
  chapterScore,
} from "@/api/evaluation";
import { chapterList } from "@/api/chapter";
import { handleTree } from "@/utils/index";

export default {
  props: {
    classInfo: Object,
  },
  data() {
    return {
      chartData: {
        columns: ["", "tdAvgScore", "zsAvgScore", "jnAvgScore", "syAvgScore"],
        rows: [{ tdAvgScore: 0, syAvgScore: 0, jnAvgScore: 0, zsAvgScore: 0 }],
      },
      chartExtend: {
        radar: {
          shape: "polygon",
          indicator: [
            { name: "态度", max: 100, color: "#51a9e1" },
            { name: "知识", max: 100, color: "#51a9e1" },
            { name: "技能", max: 100, color: "#51a9e1" },
            { name: "素养", max: 100, color: "#51a9e1" },
          ],
        },
      },
      radarSet: {
        labelMap: {
          tdAvgScore: "态度",
          syAvgScore: "素养",
          jnAvgScore: "技能",
          zsAvgScore: "知识",
        },
        itemStyle: {
          color: "rgba(255, 228, 52, 0.5)",
          borderWidth: 5,
        },
        lineStyle: {
          color: "rgba(255, 228, 52, 0.5)",
        },
        areaStyle: {
          color: "rgba(255, 228, 52, 0.5)",
        },
      },
      rankList: [],
      teamRankList: [],
      classScore: {},
      scoreList: [
        {
          id: 1,
          title: "知识分数",
          score: 0,
          path: "/classCourse/evaluation/knowledge",
        },
        {
          id: 2,
          title: "态度分数",
          score: 0,
          path: "/classCourse/evaluation/attitude",
        },
        {
          id: 3,
          title: "技能分数",
          score: 0,
          path: "/classCourse/evaluation/skill",
        },
        {
          id: 4,
          title: "素养分数",
          score: 0,
          path: "/classCourse/evaluation/attainment",
        },
        // {
        //   id: 5,
        //   title: "期末考试平均分",
        //   score: 0,
        //   path: "/classCourse/evaluation/finalExam",
        // },
        // {
        //   id: 6,
        //   title: "教师考核平均分",
        //   score: 0,
        //   path: "/classCourse/evaluation/teacherEvaluation",
        // },
      ],
      haveComplete: false,
      showList: false,
      titleText: "",
      chapterScoreList: [],
      showExport: false,
      checkAll: false,
      checked: [],
      items: [
        { label: "团队成绩排行", key: "td" },
        { label: "个人成绩排行", key: "xs" },
        { label: "个人期末成绩排行", key: "zz" },
        { label: "期末考试成绩", key: "qm" },
        { label: "教师考核成绩", key: "kh" },
      ],
      isIndeterminate: true,
    };
  },
  created() {
    this.getChapterList();
    this.getClassScore();
    this.getTeamRanking();
    this.getPersonalRanking();
  },
  computed: {
    isEnd() {
      return this.classInfo.complete;
    },
  },
  // watch: {
  //   isEnd() {
  //     this.getPersonalRanking();
  //   },
  // },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.haveComplete = res.data.find((item) => {
            return item.complete;
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    // 班级平均分
    getClassScore() {
      this.$loading.show();
      classAvg(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.classScore = res.data;
          this.scoreList[0].score = Number(
            (res.data.zsAvgScore || 0).toFixed(1)
          );
          this.scoreList[1].score = Number(
            (res.data.tdAvgScore || 0).toFixed(1)
          );
          this.scoreList[2].score = Number(
            (res.data.jnAvgScore || 0).toFixed(1)
          );
          this.scoreList[3].score = Number(
            (res.data.syAvgScore || 0).toFixed(1)
          );
          this.scoreList[4].score = Number(
            (res.data.endAvgScore || 0).toFixed(1)
          );
          this.scoreList[5].score = Number(
            (res.data.endTeacherAvgScore || 0).toFixed(1)
          );

          this.chartData.rows[0].tdAvgScore = Number(
            (res.data.tdAvgScore || 0).toFixed(1)
          );
          this.chartData.rows[0].syAvgScore = Number(
            (res.data.syAvgScore || 0).toFixed(1)
          );
          this.chartData.rows[0].jnAvgScore = Number(
            (res.data.jnAvgScore || 0).toFixed(1)
          );
          this.chartData.rows[0].zsAvgScore = Number(
            (res.data.zsAvgScore || 0).toFixed(1)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 团队排行榜
    getTeamRanking() {
      teamRanking(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.teamRankList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 个人排行榜
    getPersonalRanking() {
      // if (this.isEnd) {
      //   finalScoreList(this.$route.query.id).then((res) => {
      //     if (res.code == 0) {
      //       this.rankList = res.data;
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
      // } else {
      personalRanking(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.rankList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
      // }
    },
    handleExport(type) {
      let token = localStorage.getItem("token");
      if (type == 1) {
        window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/${this.$route.query.id}/team/export?Authorization=${token}`
        );
      } else {
        window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/${this.$route.query.id}/user/export?Authorization=${token}`
        );
      }
    },
    format(percentage) {
      return percentage + "";
    },
    goDetail(path, id) {
      if (id < 5 && !this.haveComplete) {
        this.$message.warning("尚未有章节生成了成绩");
        return;
      }
      this.$router.push({ path, query: this.$route.query });
    },
    handleShowList(type, id, name) {
      this.$loading.show();
      chapterScore({ classId: this.$route.query.id, type, id }).then((res) => {
        this.showList = true;
        this.titleText = name;
        this.$loading.hide();
        if (res.code == 0) {
          this.chapterScoreList = handleTree(res.data, "chapterId");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCheckAllChange(val) {
      let all = [];
      this.items.forEach((item) => {
        all.push(item.key);
      });
      this.checked = val ? all : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.items.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.items.length;
    },
    // 数据导出
    handleExportData() {
      // console.log(this.checked);
      let str = `${this.checked.join("=true&")}=true`;
      let token = localStorage.getItem("token");
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/${this.$route.query.id}/all/export?Authorization=${token}&${str}`
      );

      this.showExport = false;
    },
  },
};
</script>

<style lang="less" scoped>
.evaluation {
  height: 640px;
  // background-image: url("../../../assets/images/evaluation_bg.png");
  // background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    // background-image: url("../../../assets/images/title_bg.png");
    // background-size: cover;
    b {
      letter-spacing: 5px;
      font-size: 30px;
      // color: transparent;
      // background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      // background-clip: text;
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 13px;
      right: 13px;
      color: #303133;
    }
  }
  .main {
    margin: 15px 2px 0;
    .rank_row {
      .team_box,
      .personal_box {
        display: inline-block;
        width: 48%;
        // border: solid 1px #dcdfe6;
        vertical-align: top;
        &.team_box {
          margin-right: 40px;
        }
        .tr {
          padding: 5px 18px;
          color: rgba(42, 42, 42, 0.6);
          background: #fff;
          font-size: 15px;
          text-align: left;
          .idx {
            margin-right: 28px;
          }
          .score {
            float: right;
            &.ml {
              margin-left: 20px;
            }
          }
        }
        .list_box {
          display: inline-block;
          padding: 0 24px;
          width: 450px;
          height: 210px;
          font-size: 16px;
          text-align: left;
          background: #fff;
          // box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          overflow-y: auto;
          &::-webkit-scrollbar {
            width: 6px;
            background-color: #d1d1d1;
          }

          &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
            -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
            background-color: #d1d1d1;
          }

          &::-webkit-scrollbar-thumb {
            box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
            -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
            background-color: #3d3d3d;
          }
          .row {
            padding: 13px 0 6px;
            line-height: 1;
            color: #333;
            border-bottom: dashed 1px #F56C6C;
            // border-image: linear-gradient(to right, #303133, transparent) 1 10;
            cursor: pointer;
            overflow: hidden;
            .idx {
              display: inline-block;
              width: 18px;
              margin-right: 35px;
              color: red;
            }
            .score {
              float: right;
              width: 48px;
              text-align: right;
              color: red;
              &.oc {
                color: #ff7800;
                margin-left: 30px;
              }
            }
          }
        }
      }
      .radar {
        display: inline-block;
        margin: 0 16px;
        width: 280px;
        vertical-align: top;
        .radar_box {
          padding: 10px 0;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
        }
      }
      .box_title {
        display: inline-block;
        padding: 50px 10px;
        width: 40px;
        height: 210px;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        background-color: #f56c6c;
        // border: solid 1px rgba(4, 20, 40, 0.1);
        // box-shadow: #6be4f7 0px 0px 5px inset;
        overflow: hidden;
        vertical-align: top;
        .export-btn {
          float: right;
          margin-top: 5px;
          color: #fff;
        }
      }
    }

    .score_row {
      margin-top: 15px;
      .score_box {
        display: inline-block;
        width: 290px;
        &:not(:last-child) {
          margin-right: 10px;
        }
        .score_title {
          display: inline-block;
          padding: 35px 10px;
          // height: 48px;
          // line-height: 48px;
          width: 40px;
          height: 160px;
          font-size: 16px;
          color: #fff;
          font-weight: bold;
          background-color: #f56c6c;
          vertical-align: top;
          // border: solid 1px rgba(4, 20, 40, 0.1);
          // box-shadow: #303133 0px 0px 5px inset;
        }
        .circle_box {
          display: inline-block;
          position: relative;
          // padding-top: 28px;
          padding: 0 30px;
          height: 160px;
          // box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          background: #fff;
          cursor: pointer;
          .score-text {
            line-height: 160px;
            color: red;
            font-size: 40px;
            font-weight: bold;
          }
          ::v-deep .el-progress__text {
            // padding-right: 10px;
            color: #303133;
            font-size: 28px !important;
          }
          .text {
            position: absolute;
            top: 47%;
            right: 35%;
            color: #303133;
          }
        }
      }
    }
  }
  ::v-deep .score-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }

  .el-checkbox {
    display: block;
    margin-bottom: 10px;
  }
}
</style>